/**************************************************
 * Nombre:       Formulario_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircle,
    AccountCircleOutlined,
    ArticleOutlined,
    BadgeOutlined,
    Flag,
    FlagOutlined,
    LocalShippingOutlined,
    Mail,
    MapsHomeWorkOutlined,
    Preview,
    SignpostOutlined,
    SmartphoneOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Pedido from "./Formulario_Producto_Pedido";
import Tarjetas_Producto from "../Tarjeta/Tarjetas_Producto";
import {ESTADOSPEDIDOS} from "../../Constantes";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {irUrl} from "../../Utilidades/irUrl";

const Formulario_Pedido = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'productos',
        Formulario: Formulario_Producto_Pedido,
        nombre: 'Actualizar',
        Tarjeta: Tarjetas_Producto
    })


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSPEDIDOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Estado Pago'} {...props} dato={'estadoPago'}
                                  opciones={ESTADOSPEDIDOS.map((it) => it.nombre)}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos Cliente</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircle} nombre={'Nombre'} dato={'nombres'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props} />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos Pago </Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'ID Pago'} dato={'idPago'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Estado Pago'} dato={'estadoPago'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Detalle Pago'} dato={'detallePago'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Metodo Pago'} dato={'metodoPago'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={AccountCircleOutlined} nombre={'Valor Transaccion'}
                                   dato={'valorTransaccion'} {...props}
                                   editable={false}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Productos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Flag} nombre={'Estado'} dato={'estadoMexico'} {...props}

                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Flag} nombre={'Municipio'} dato={'municipio'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Flag} nombre={'Valor Envio'}
                                   dato={'valorEnvio'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Token Guia'} editable={false}
                                  dato={'tokenEnvio'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Colonia o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Nombre de Calle'}
                                  dato={'calle'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Número exterior/interior'}
                                  dato={'numero'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Referencias adiciónales'} dato={'referencia'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha nombre={'Fecha Creacion Guia'} dato={'fechaCreacionGuia'} {...props} />
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        disabled={props.props.getValues('linkGuia')}
                        onClick={() => props.click()} startIcon={<LocalShippingOutlined/>} variant={'outlined'}>Generar
                        Guia</Button>
                </Grid>

                <Grid container size={12}>
                    <IngresoTextoBoton Icono={ArticleOutlined} nombre={'Link de Guia'} dato={'linkGuia'} {...props}
                                       click={() => irUrl(props.props.getValues('linkGuia'))} IconoFinal={Preview}
                                       editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={LocalShippingOutlined} nombre={'Numero de Orden'}
                                  dato={'numGuia'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={LocalShippingOutlined} nombre={'Empresa de envio'}
                                  dato={'empresaEnvio'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Notas Internas</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Notas Internas'} dato={'notas'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pedido